import { createBrowserRouter, Outlet, Navigate } from 'react-router-dom'
import { AuthenticatedTemplate, UnauthenticatedTemplate } from '@azure/msal-react'
import { useAuth } from './auth/useAuth'
import AppLayout from './components/layout/AppLayout'
import LoginPage from './pages/LoginPage'
import EmployeesPage from './pages/employees/EmployeesPage'
import EmployeeDetailPage from './pages/employees/EmployeeDetailPage'
import EmployeeFormPage from './pages/employees/EmployeeFormPage'
import AbsencesPage from './pages/absences/AbsencesPage'
import AbsenceCalendarPage from './pages/absences/AbsenceCalendarPage'
import MyRequestsPage from './pages/absences/MyRequestsPage'
import MyProfileEditPage from './pages/MyProfileEditPage'
import NewAbsenceRequest from './pages/absences/NewAbsenceRequest'
import AllRequestsPage from './pages/absences/AllRequestsPage'
import MyProfilePage from './pages/MyProfilePage'
import ContractorsPage from './pages/contractors/ContractorsPage'
import ContractorDetailPage from './pages/contractors/ContractorDetailPage'
import ContractorFormPage from './pages/contractors/ContractorFormPage'
import AdminPage from './pages/admin/AdminPage'
import ActivityLogPage from './pages/admin/ActivityLogPage'
import PensionContributionsPage from './pages/pensionContributions/PensionContributionsPage'
import PensionContributionDetailPage from './pages/pensionContributions/PensionContributionDetailPage'
import PensionContributionFormPage from './pages/pensionContributions/PensionContributionFormPage'
import DocumentDefinitionsPage from './pages/documents/DocumentDefinitionsPage'
import DocumentDefinitionDetailPage from './pages/documents/DocumentDefinitionDetailPage'
import DocumentDefinitionFormPage from './pages/documents/DocumentDefinitionFormPage'

const IS_MOCK = import.meta.env.VITE_MOCK_AUTH === 'true'

/** Přesměrování výchozí stránky podle role */
function HomeRedirect() {
  const { isHR, isAdmin, isManager } = useAuth()
  if (isHR || isAdmin || isManager) return <Navigate to="/employees" replace />
  return <Navigate to="/my-profile" replace />
}

/** Ochrana přihlášením — v mock režimu přeskočena */
function AuthGuard() {
  if (IS_MOCK) return <Outlet />
  return (
    <>
      <UnauthenticatedTemplate>
        <LoginPage />
      </UnauthenticatedTemplate>
      <AuthenticatedTemplate>
        <Outlet />
      </AuthenticatedTemplate>
    </>
  )
}

export const router = createBrowserRouter([
  {
    element: <AuthGuard />,
    children: [
      {
        element: (
          <AppLayout>
            <Outlet />
          </AppLayout>
        ),
        children: [
          { path: '/',                        element: <HomeRedirect /> },
          { path: '/employees',               element: <EmployeesPage /> },
          { path: '/employees/new',           element: <EmployeeFormPage /> },
          { path: '/employees/:id/edit',      element: <EmployeeFormPage /> },
          { path: '/employees/:id',           element: <EmployeeDetailPage /> },
          { path: '/contractors',             element: <ContractorsPage /> },
          { path: '/contractors/new',         element: <ContractorFormPage /> },
          { path: '/contractors/:id/edit',    element: <ContractorFormPage /> },
          { path: '/contractors/:id',         element: <ContractorDetailPage /> },
          { path: '/absences',                element: <AbsencesPage /> },
          { path: '/absences/calendar',       element: <AbsenceCalendarPage /> },
          { path: '/absences/all',            element: <AllRequestsPage /> },
          { path: '/my-requests',             element: <MyRequestsPage /> },
          { path: '/requests/new',            element: <NewAbsenceRequest /> },
          { path: '/my-profile',             element: <MyProfilePage /> },
          { path: '/my-profile/edit',       element: <MyProfileEditPage /> },
          { path: '/admin',                          element: <AdminPage /> },
          { path: '/admin/activity-log',             element: <ActivityLogPage /> },
          { path: '/pension-contributions',          element: <PensionContributionsPage /> },
          { path: '/pension-contributions/new',      element: <PensionContributionFormPage /> },
          { path: '/pension-contributions/:id',      element: <PensionContributionDetailPage /> },
          { path: '/pension-contributions/:id/edit', element: <PensionContributionFormPage /> },
          { path: '/documents',                      element: <DocumentDefinitionsPage /> },
          { path: '/documents/new',                  element: <DocumentDefinitionFormPage /> },
          { path: '/documents/:id/edit',             element: <DocumentDefinitionFormPage /> },
          { path: '/documents/:id',                  element: <DocumentDefinitionDetailPage /> },
        ],
      },
    ],
  },
])
